import { EventFilter, EventFilterKernel } from './event-filter';

export default EventFilter;
export { EventFilterKernel };
